import React from 'react';
import { IoOpenOutline } from 'react-icons/io5';
import { useTranslation } from '../i18n';
import enlaces from '../../assets/enlaces/linksData';
import * as S from './LinksSection.styles';

function LinksSection() {
  const t = useTranslation();

  // Map of link IDs to translation keys
  const translationKeyMap = {
    'iasd': 'iasd',
    'noticias-iasd': 'noticiasIasd',
    'whatsapp-uu': 'whatsappUu',
    'feliz7play': 'feliz7play',
    'videos-iasd': 'videosIasd',
    'radio-nt': 'radioNt',
    'materiales-iasd': 'materialesIasd',
    'para-el-sabado': 'paraElSabado',
    'galeria-imagenes': 'galeriaImagenes',
    'leccion-jovenes': 'leccionJovenes',
    'ja-materiales': 'jaMateriales',
    'accion-joven': 'accionJoven',
    'conquistadores': 'conquistadores',
    'ministerio-nino': 'ministerioNino',
    'recursos-biblicos': 'recursosBiblicos',
    'meditaciones-2025': 'meditaciones2025',
    '7me': 'seme',
    'probad-ved': 'probadVed',
  };

  return (
    <S.LinksGrid>
      {enlaces.map((enlace) => {
        const translationKey = translationKeyMap[enlace.id];
        const title = t(`links.items.${translationKey}.title`);
        const description = t(`links.items.${translationKey}.description`);
        
        return (
          <S.LinkCard 
            key={enlace.id}
            href={enlace.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${t('links.visitLabel')} ${title}`}
          >
            <S.LinkImageContainer>
              <S.LinkImage src={enlace.icon} alt={title} />
            </S.LinkImageContainer>
            <S.LinkContent>
              <S.LinkTitle>{title}</S.LinkTitle>
              <S.LinkDescription>{description}</S.LinkDescription>
            </S.LinkContent>
            <S.ExternalLinkBadge>
              <IoOpenOutline />
            </S.ExternalLinkBadge>
          </S.LinkCard>
        );
      })}
    </S.LinksGrid>
  );
}

export default LinksSection;

